import { LitElement, css, html, nothing } from "lit";
import "../../../../../../../legl-ui/lds-chip";
import { neutral } from "../../../../../../../legl-ui/lds-colours";
import { spacing } from "../../../../../../../legl-ui/lds-spacing";

export class LeglLawyersTableChips extends LitElement {
  static get styles() {
    return css`
            .wrapper {
                margin-bottom: ${spacing.s};
                display: flex;
                gap: ${spacing.xs};
                flex-wrap: wrap;
            }

            .filter-label {
                align-self: center;
                color: ${neutral["800"]};
                display: flex;
                font-size: 14px;
                margin-right: 10px;
            }

            .filter-label legl-icon {
                position: relative;
                top: 3px;
                margin-right: 5px;
                font-size: 12px;
            }
        `;
  }

  static get properties() {
    return {
      chips: { attribute: false },
      clickHandler: { attribute: false },
    };
  }

  render() {
    return html`
            ${
              this.chips.length
                ? html` <div class="wrapper">
                      ${
                        this.chips.length >= 1
                          ? html`
                                <div class="filter-label">
                                    <legl-icon
                                        name="legl-icon-filter"
                                    ></legl-icon>
                                    Filters:
                                </div>
                            `
                          : nothing
                      }
                      ${this.chips.map(
                        (filter) =>
                          html` <lds-chip
                                  .text="${filter.label}"
                                  .clickHandler=${(value) =>
                                    this.clickHandler(
                                      filter.column,
                                      filter.value,
                                    )}
                              ></lds-chip>`,
                      )}
                  </div>`
                : nothing
            }
        `;
  }
}

if (!customElements.get("legl-lawyers-table-chips")) {
  customElements.define("legl-lawyers-table-chips", LeglLawyersTableChips);
}
